<template>
  <div class="logo-container">
    <img class="logo" src="@/assets/logo.png" v-if="isMobile">
    <h1 v-if="!isMobile">{{ systemTitle }}</h1>
  </div>
</template>

<script>
export default {
  computed:{
    isMobile(){
      return this.$store.state.app.isMobile;
    },
    systemTitle(){
      return this.$store.state.app.systemTitle;
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-container {
  display: flex;
  height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: var(--system-logo-background);
  border-bottom: 1px solid #ebeef5;
  padding:13px 15px;
  .logo {
    width: 35px;
    height: 35px;
  }
  h1 {
    font-size: 20px;
    white-space: nowrap;
    color: var(--system-logo-color);
  }
}
</style>